// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__286hw","additionalInfo":"AgreementModal_additionalInfo__3mA3F"};